module.exports = __webpack_public_path__ + "img/Egipt.6ca91f3d.png";